module.exports = __webpack_public_path__ + "img/faerie_dragon_small.35d37376.png";